import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
function FeedNewsCom() {
  const pagination = useRef();
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));
  const userId = localStorage.getItem("userId");

  const [currentPage, setCurrentPage] = useState(1);

  const [modal, setModal] = useState(false);
  const [newstitle, setNewstitle] = useState("");
  const [slogan, setSlogan] = useState("");
  const [talktype, setTalktype] = useState("");
  const [desc, setDesc] = useState("");
  const [image, setImage] = useState("");
  const [err, setErr] = useState("");
  const [msg, setSmg] = useState("");
  const [btnstatus, setBtnstatus] = useState(true);
  const [newslist, setNewslist] = useState([]);
  const [newsId, setNewsId] = useState("");
  var totalPosts = newslist?.length;
  var postPerPage = 10;
  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions
    ? JSON.parse(get_oermission_data.login_Permission.permissions)
    : "";
  const hr_permission = get_oermission_data.login_Permission.permissions;

  const hr_permission_arr = Array();
  if (hr_permission) {
    const hr_permission_arr1 = JSON.parse(hr_permission).split(",");
    hr_permission_arr1.map((item, ind) => {
      hr_permission_arr.push(item);
    });
  }

  const handleShowModal = () => {
    setModal(true);
  };
  const handleClose = () => {
    setErrnewtitle("");
    setNewstitle("");
    setSlogan("");
    setErrslogan("");
    setErrimage("");
    setImage("");
    setTalktype("");
    setErrtalktype("");
    setModal(false);
    setNewsId("");
    setDesc("");
    setSmg("");
  };
  const [errnewtitle, setErrnewtitle] = useState("");
  const [errslogan, setErrslogan] = useState("");
  const [errtalktype, setErrtalktype] = useState("");
  const [errimage, setErrimage] = useState("");
  const handleSave = (e) => {
    e.preventDefault();
    setErrslogan("");
    setErrtalktype("");
    setErrnewtitle("");
    setErrimage("");
    if (newstitle == "") {
      setErrnewtitle("red");
      return false;
    }
    if (slogan == "") {
      setErrslogan("red");
      return false;
    }
    if (
      image?.type?.toLowerCase() !== "image/png" &&
      image?.type?.toLowerCase() !== "image/jpeg" &&
      image?.type?.toLowerCase() !== "image/jpg"
    ) {
      setErrimage("red");
      return false;
    }
    if (talktype == "") {
      setErrtalktype("red");
      return false;
    }
    if (newsId != "") {
      editNews();
    } else {
      addNews();
    }
  };
  function editNews() {
    setBtnstatus(false);
    const formdata = new FormData();
    formdata.append("newsID", newsId);
    formdata.append("title", newstitle);
    formdata.append("tagline", slogan);
    formdata.append("type", talktype);
    formdata.append("remark", desc);
    formdata.append("newsimage", image);
    formdata.append("updatedRequestId", userId);
    const response = fetch(SERVER_URL + `api/news/update-news-feeds`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setErr("green");
          setSmg(data.msg);
          setTimeout(function () {
            setImage("");
            getNewsFeeds();
            handleClose();
            setBtnstatus(true);
          }, 1000);
        }
      });
  }

  function addNews() {
    setBtnstatus(false);
    const formdata = new FormData();
    formdata.append("empID", userId);
    formdata.append("title", newstitle);
    formdata.append("tagline", slogan);
    formdata.append("type", talktype);
    formdata.append("remark", desc);
    formdata.append("newsimage", image);

    const response = fetch(SERVER_URL + `api/news/add-news`, {
      method: "post",
      headers: {
        Accept: "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setErr("green");
          setSmg("News Feeds Successfully Added.");
          setTimeout(function () {
            setImage("");
            getNewsFeeds();
            handleClose();
            setBtnstatus(true);
          }, 1000);
        }
      });
  }
  var file = "";
  const handlefile = async (e) => {
    file = e.target.files[0];
    setImage(file);
  };
  useEffect(() => {
    getNewsFeeds();
  }, []);
  const getNewsFeeds = async () => {
    const response = await fetch(SERVER_URL + `api/news`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setNewslist(data.result);
        }
      });
  };
  const handleStatus = (status, id) => {
    const user_login_id = localStorage.getItem("userId");
    const status_update = status == 1 ? 0 : 1;
    const response = fetch(SERVER_URL + `api/news/update-news-status`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        newsID: id,
        status: status_update,
        updatedRequestId: user_login_id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        getNewsFeeds();
      });
  };
  const handleDelete = (id) => {
    const user_login_id = localStorage.getItem("userId");
    const response = fetch(SERVER_URL + `api/news/delete-news-feed`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        newsID: id,
        is_deleted: "1",
        updatedRequestId: user_login_id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        getNewsFeeds();
      });
  };
  const getNews = (id) => {
    setNewsId(id);
    setModal(true);
    getNewsById(id);
  };
  const getNewsById = async (id) => {
    const response = await fetch(SERVER_URL + `api/news/single-news-feeds`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        newsID: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          var resdata = data.result;
          setNewstitle(resdata.title);
          setSlogan(resdata.tagline);
          setTalktype(resdata.news_type);
          setDesc(resdata.remark);
        }
      });
  };
  return (
    <>
      {" "}
      <Modal show={modal} size="md" id="confirm_login">
        <div className="modal-body">
          <div className="decorative-shape shape-1"></div>
          <div className="decorative-shape shape-2"></div>
          <button
            type="button"
            className="float-end btn_close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="icon icon-cross fw-bold"></i>
          </button>
          <div
            className="dash_white_box_ttl text-center"
            id="exampleModalLabel"
          >
            {newsId ? "Edit News" : "Add News"}
          </div>
          <div className="mb-2">
            <label className="col-form-label">News Title :</label>
            <input
              style={{ borderColor: errnewtitle }}
              type="text"
              onChange={(e) => {
                setNewstitle(e.target.value);
              }}
              value={newstitle}
              className="form-control"
            />
          </div>
          <div className="mb-2">
            <label className="col-form-label">Slogan</label>
            <input
              type="text"
              style={{ borderColor: errslogan }}
              onChange={(e) => {
                setSlogan(e.target.value);
              }}
              value={slogan}
              className="form-control"
            />
          </div>
          <div className="mb-2" style={{ borderColor: errimage }}>
            <label className="col-form-label">Upload Image</label>
            <div className="input-group" style={{ borderColor: errimage }}>
              <input
                type="file"
                style={{ borderColor: errimage }}
                name="file"
                onChange={handlefile}
                required=""
                className="form-control"
                id="inputGroupFile01"
              />
              <input
                type="submit"
                className="btn_7"
                value="Upload"
                name="upload"
              />
            </div>
          </div>
          <div className="mb-2">
            <label className="col-form-label">Type of Talks</label>
            <select
              style={{ borderColor: errtalktype }}
              className="form-select"
              value={talktype}
              onChange={(e) => {
                setTalktype(e.target.value);
              }}
            >
              <option>Select Type of Talks</option>
              <option value="1">Client Feedback</option>
              <option value="2">Feed News</option>
              <option value="3">Hive Talks</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="col-form-label">Description</label>
            <textarea
              value={desc}
              className="form-control"
              onChange={(e) => {
                setDesc(e.target.value);
              }}
              id="description"
            ></textarea>
          </div>
          <div className="modalfooter">
            <span className="mb10 d-block text-right" style={{ color: err }}>
              {msg}
            </span>
            <div className="row">
              <div className="col-md-6 pr07">
                <button
                  type="button"
                  onClick={handleSave}
                  className="btn_5 w-100"
                >
                  Save
                </button>
              </div>
              <div className="col-md-6 pl07">
                <button
                  type="button"
                  style={{ display: btnstatus ? "block" : "none" }}
                  onClick={handleClose}
                  className="btn_6 w-100"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <div className="page-header">
        <h1>
          {hr_permission_arr?.includes("31") && (
            <button onClick={handleShowModal} className="btn_5 mt05 float-end">
              Add News
            </button>
          )}
          Feed News
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li className="current">
            <span>/</span> Feed News
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="mb-4 wp100">
          <table className="table_style_1">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Image</th>
                <th>News Title</th>
                <th>Slogan</th>
                <th style={{ width: "130px" }}>Talk Type</th>
                <th style={{ width: "400px" }}>Description</th>
                <th style={{ width: "50px" }}>Status</th>
                <th style={{ width: "200px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {newslist.map((item, ind) => {
                return (
                  <tr key={ind + 1}>
                    <td>{ind + 1}</td>
                    <td>
                      <img
                        src={`${SERVER_URL + "news/" + item?.image}`}
                        className="images_sty_1"
                      />
                    </td>
                    <td>{item?.title}</td>
                    <td>{item?.tagline}</td>
                    <td>{item?.news_type == 2 ? "Feed News" : ""}</td>
                    <td>{item?.remark}</td>
                    <td>
                      <span
                        onClick={(e) =>
                          handleStatus(item?.status, item?.newsID)
                        }
                      >
                        {item?.status == 1 ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      {hr_permission_arr?.includes("32") && (
                        <button
                          onClick={(e) => {
                            getNews(item.newsID);
                          }}
                          className="btn_7 mr03"
                        >
                          Edit
                        </button>
                      )}
                      {hr_permission_arr?.includes("33") && (
                        <button
                          onClick={(e) => {
                            handleDelete(item?.newsID);
                          }}
                          className="btn_8"
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="8">
                  <span
                    onClick={(e) =>
                      pagination.current.setState({ selected: 10 - 1 })
                    }
                  ></span>
                  <ReactPaginate
                    ref={pagination}
                    pageCount={Math.ceil(totalPosts / postPerPage)}
                    pageRangeDisplayed={4}
                    marginPagesDisplayed={1}
                    onPageChange={(page) => setCurrentPage(page)}
                    containerClassName="pagination"
                    activeClassName="active"
                    pageLinkClassName="page-link"
                    breakLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    pageClassName="page-item"
                    breakClassName="page-item"
                    nextClassName="page-item"
                    previousClassName="page-item"
                    previousLabel={<>&laquo;</>}
                    nextLabel={<>&raquo;</>}
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default FeedNewsCom;
